// import * as React from 'react';

import EmptyState from '@pinecast/common/EmptyState';
import type {SubscriptionsPage_tipJarSubscriptions} from '@pinecast/gql/__generated_tj__/SubscriptionsPage';
import {defineMessages, FormattedMessage} from '@pinecast/i18n';

import SubscriptionsPageRecurringDonationPodcast from './SubscriptionsPageRecurringDonationPodcast';

const messages = defineMessages({
  empty: {
    id: 'tj=spa.SubscriptionsPageRecurringDonationList.empty',
    description: 'Generic empty state for tip jar subscriptions',
    defaultMessage: "You haven't subscribed to any podcasts yet.",
  },
  emptyCopy: {
    id: 'tj=spa.SubscriptionsPageRecurringDonationList.emptySubscriptions.copy',
    description: 'Generic empty state copy for tip jar subscriptions',
    defaultMessage:
      "When you become a recurring donor to a podcast's tip jar, you'll see your subscription appear here.",
  },
});

type Props = {
  subscriptions: ReadonlyArray<SubscriptionsPage_tipJarSubscriptions>;
};

const SubscriptionsPageRecurringDonationList = ({subscriptions}: Props) => {
  if (!subscriptions.length) {
    return (
      <EmptyState
        title={<FormattedMessage {...messages.empty} />}
        copy={<FormattedMessage {...messages.emptyCopy} />}
      />
    );
  }

  return (
    <>
      {subscriptions.map(sub => (
        <SubscriptionsPageRecurringDonationPodcast
          key={sub.id}
          subscription={sub}
        />
      ))}
    </>
  );
};

export default SubscriptionsPageRecurringDonationList;
